// @ts-nocheck
(function () {
  if (window.__scatterLayerBootstrapped) return;
  window.__scatterLayerBootstrapped = true;

  // ---------------- utils ----------------
  // Measure page size while temporarily collapsing all scatter hosts so they don't inflate scrollHeight
  function getPageAreaExcludingHosts() {
    var doc = document.documentElement;
    var body = document.body || document.createElement('body');

    var hosts = Array.prototype.slice.call(document.querySelectorAll('.scatter-portal-host'));
    var prevHeights = hosts.map(function (h) { return h.style.height; });
    hosts.forEach(function (h) { h.style.height = '0px'; });

    var w = Math.max(doc.clientWidth, window.innerWidth || 0);
    var h = Math.max(doc.scrollHeight, body.scrollHeight, doc.offsetHeight, body.offsetHeight);

    hosts.forEach(function (h, i) { h.style.height = prevHeights[i]; });

    return { w: w, h: h };
  }

  function rand(min, max) { return Math.random() * (max - min) + min; }
  function sign() { return Math.random() < 0.5 ? -1 : 1; }
  function overlaps(a, b, g) {
    return !(
      a.right + g <= b.left ||
      a.left >= b.right + g ||
      a.bottom + g <= b.top ||
      a.top >= b.bottom + g
    );
  }

  function getLayerKey(layer) {
    // Prefer explicit data-scatter-id, fall back to element id, else generate stable-ish key
    var key = layer.getAttribute('data-scatter-id') || layer.id;
    if (!key) {
      key = 'scatter-' + (layer.dataset.sectionId || '') + '-' + Math.random().toString(36).slice(2);
      layer.setAttribute('data-scatter-id', key);
    }
    return key;
  }

  // Create/find a unique portal host per layer
  function ensurePortalHost(layer) {
    var key = getLayerKey(layer);
    var hostId = 'scatter-host-' + key;

    var host = document.getElementById(hostId);
    if (!host) {
      host = document.createElement('div');
      host.id = hostId;
      host.className = 'scatter-portal-host';
      // classify for z-index intent
      if (layer.classList.contains('landing-sticker-layer') || layer.classList.contains('collection-sticker-layer')) {
        host.classList.add('host--stickers');
      }
      if (layer.classList.contains('landing-footprint-layer') || layer.classList.contains('collection-footprint-layer')) {
        host.classList.add('host--footprints');
      }

      host.style.position = 'absolute';     // scrolls with page
      host.style.left = '0';
      host.style.top = '0';
      host.style.pointerEvents = 'none';    // never intercept clicks

      // ---- z-index: between background (0) and content (>=2/3) ----
      var z = 1; // footprints default
      if (host.classList.contains('host--stickers')) z = 2;

      // Keep under product grid if it has explicit z-index
      try {
        var prod = document.querySelector('.collection-products');
        if (prod) {
          var prodZ = parseInt(getComputedStyle(prod).zIndex, 10);
          if (!isNaN(prodZ)) z = Math.min(z, prodZ - 1);
        }
      } catch (e) {}

      // Allow manual override via data-z on layer
      var attrZ = layer.getAttribute('data-z');
      if (attrZ !== null) z = +attrZ || z;

      host.style.zIndex = String(z);

      document.body.appendChild(host);
    }
    layer.__scatterHost = host;
    return host;
  }

  // Create/find a unique canvas per host
  function ensureCanvasForHost(layer, host) {
    var key = getLayerKey(layer);
    var canvasId = 'scatter-canvas-' + key;
    var canvas = document.getElementById(canvasId);

    if (!canvas) {
      // try to reuse a .scatter-canvas inside layer (from the snippet), else create one
      canvas = layer.querySelector('.scatter-canvas') || document.createElement('div');
      canvas.classList.add('scatter-canvas');
      canvas.id = canvasId;
      canvas.style.position = 'relative';
      canvas.style.pointerEvents = 'none';
      canvas.style.margin = '0';
      canvas.style.padding = '0';
      host.appendChild(canvas);
    } else if (canvas.parentNode !== host) {
      host.appendChild(canvas);
    }

    return canvas;
  }

  function readSettings(layer) {
    // Read attributes off the layer each time we layout — supports live Theme Editor updates
    var s = {};
    s.src    = layer.getAttribute('data-img');
    s.count  = +layer.getAttribute('data-count')  || 5;
    s.minVW  = +layer.getAttribute('data-min-vw') || 8;
    s.maxVW  = +layer.getAttribute('data-max-vw') || 22;
    s.gutter = +layer.getAttribute('data-gutter') || 75;
    s.maxRot = +layer.getAttribute('data-rot')    || 45;

    // mirroring
    var mirrEnabled = (layer.getAttribute('data-mirror') || '').toLowerCase() === 'true';
    var mirrEvery   = parseInt(layer.getAttribute('data-mirror-every'), 10);
    var mirrProb    = parseFloat(layer.getAttribute('data-mirror-prob'));
    s.mirrorEnabled = mirrEnabled;
    s.mirrorEvery   = (mirrEvery > 1) ? mirrEvery : 0;
    s.mirrorProb    = (!isNaN(mirrProb) && mirrProb > 0 && mirrProb < 1) ? mirrProb : (1 / 3);

    // ensure some are visible on first viewport
    s.viewportQuota = Math.min(s.count, Math.max(1, Math.ceil(s.count * 0.4)));
    return s;
  }

  // Size a specific host+canvas to the real page size (excluding hosts themselves)
  function sizeHostAndCanvasToPage(layer, host, canvas) {
    var area = getPageAreaExcludingHosts();
    host.style.width  = area.w + 'px';
    host.style.height = area.h + 'px';
    canvas.style.width  = area.w + 'px';
    canvas.style.height = area.h + 'px';
    return area;
  }

  function initLayer(layer) {
    if (layer.__scatterInit) return;
    layer.__scatterInit = true;

    var key = getLayerKey(layer);
    var host = ensurePortalHost(layer);
    var canvas = ensureCanvasForHost(layer, host);

    var imgMeta = { w: 1000, h: 1000 };
    function loadMeta(src) {
      return new Promise(function (resolve) {
        if (!src) { resolve(imgMeta); return; }
        var i = new Image();
        i.onload  = function () { resolve({ w: i.naturalWidth || i.width, h: i.naturalHeight || i.height }); };
        i.onerror = function () { resolve(imgMeta); };
        i.decoding = 'async';
        i.src = src;
      });
    }

    var lastResizeKey = '';

    function layout(settings) {
      var area = sizeHostAndCanvasToPage(layer, host, canvas);
      var vW = area.w, vH = area.h;
      var viewportH = Math.max(window.innerHeight || 0, 1);

      // clear
      while (canvas.firstChild) canvas.removeChild(canvas.firstChild);

      var placed = [];
      var tries = 0, maxTries = 6000;

      function placeOne(yMin, yMax) {
        for (var t = 0; t < 200 && tries < maxTries; t++) {
          tries++;
          var vw = rand(settings.minVW, settings.maxVW);
          var wPx = (vw / 100) * vW;
          var hPx = wPx / (imgMeta.w / imgMeta.h);

          var xMax = Math.max(0, vW - wPx);
          var yMaxEff = Math.max(0, (typeof yMax === 'number' ? yMax : vH) - hPx);
          var yMinEff = Math.max(0, (typeof yMin === 'number' ? yMin : 0));
          if (xMax <= 0 || yMaxEff < yMinEff) return false;

          var x = rand(0, xMax);
          var y = rand(yMinEff, yMaxEff);
          var box = { left: x, top: y, right: x + wPx, bottom: y + hPx };

          var ok = true;
          for (var j = 0; j < placed.length; j++) { if (overlaps(box, placed[j], settings.gutter)) { ok = false; break; } }
          if (!ok) continue;

          // mirroring decision
          var doMirror = false;
          if (settings.mirrorEnabled) {
            if (settings.mirrorEvery > 1) {
              doMirror = ((placed.length + 1) % settings.mirrorEvery) === 0;
            } else {
              doMirror = Math.random() < settings.mirrorProb; // ~1/3
            }
          }

          var angle = (rand(0, settings.maxRot) * sign());
          var transform = (doMirror ? 'scaleX(-1) ' : '') + 'rotate(' + angle + 'deg)';

          var wrap = document.createElement('div');
          wrap.className = 'sticker' + (doMirror ? ' is-mirrored' : '');
          wrap.style.position = 'absolute';
          wrap.style.left = x + 'px';
          wrap.style.top  = y + 'px';
          wrap.style.width  = wPx + 'px';
          wrap.style.height = hPx + 'px';
          wrap.style.transform = transform;
          wrap.style.pointerEvents = 'none';
          if (doMirror) wrap.setAttribute('data-mirrored', 'true');

          var img = document.createElement('img');
          img.src = settings.src;
          img.alt = '';
          img.decoding = 'async';
          img.loading = 'lazy';
          img.style.width = '100%';
          img.style.height = 'auto';
          img.style.display = 'block';
          img.style.pointerEvents = 'none';

          wrap.appendChild(img);
          canvas.appendChild(wrap);
          placed.push(box);
          return true;
        }
        return false;
      }

      // 1) ensure some visible at top
      var vp = 0;
      for (var i = 0; i < settings.viewportQuota && tries < maxTries; i++) {
        if (placeOne(0, viewportH)) vp++; else break;
      }
      // 2) fill rest across full page height
      for (var k = vp; k < settings.count && tries < maxTries; k++) {
        if (!placeOne(0, vH)) {
          if (!placeOne(0, Math.min(vH, Math.max(viewportH, vH / 3)))) break;
        }
      }
    }

    function shouldRelayout() {
      var w = window.innerWidth || document.documentElement.clientWidth;
      var o = (screen.orientation && screen.orientation.type) || '';
      var key = w + '|' + o;
      var changed = key !== lastResizeKey;
      lastResizeKey = key;
      return changed;
    }

    // Initial + reactive layout
    var currentSettings = readSettings(layer);
    loadMeta(currentSettings.src).then(function (meta) {
      imgMeta = meta;
      layout(currentSettings);
    });

    function onResize() {
      if (!shouldRelayout()) { sizeHostAndCanvasToPage(layer, host, canvas); return; }
      currentSettings = readSettings(layer);
      layout(currentSettings);
    }

    // Keep synced with Theme Editor updates (attributes change on the layer)
    var mo;
    if (window.MutationObserver) {
      mo = new MutationObserver(function (muts) {
        var changed = muts.some(function (m) {
          return m.type === 'attributes' && /^data-(img|count|min-vw|max-vw|gutter|rot|mirror|mirror-every|mirror-prob)$/.test(m.attributeName);
        });
        if (changed) {
          currentSettings = readSettings(layer);
          layout(currentSettings);
        }
      });
      mo.observe(layer, { attributes: true });
    }

    // Resize listeners
    window.addEventListener('resize', onResize, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', onResize, { passive: true });

    // Grow/shrink with document height
    var ro;
    if (window.ResizeObserver) {
      var doc = document.documentElement;
      var body = document.body || document.createElement('body');
      var lastDocH = Math.max(doc.scrollHeight, body.scrollHeight, doc.offsetHeight, body.offsetHeight);
      ro = new ResizeObserver(function () {
        var h = Math.max(doc.scrollHeight, body.scrollHeight, doc.offsetHeight, body.offsetHeight);
        if (Math.abs(h - lastDocH) > 200) {
          lastDocH = h;
          currentSettings = readSettings(layer);
          layout(currentSettings);
        } else {
          // Keep host/canvas synced without re-laying out stickers
          sizeHostAndCanvasToPage(layer, host, canvas);
        }
      });
      ro.observe(body);
    }

    // Store teardown so Theme Editor can unload cleanly
    layer.__scatterDestroy = function () {
      if (mo) try { mo.disconnect(); } catch(e) {}
      if (ro) try { ro.disconnect(); } catch(e) {}
      window.removeEventListener('resize', onResize);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', onResize);
      // Remove host+canvas for this layer only
      var host = layer.__scatterHost;
      if (host && host.parentNode) host.parentNode.removeChild(host);
      layer.__scatterInit = false;
      layer.__scatterHost = null;
    };
  }

  function initAll(root) {
    (root || document).querySelectorAll('.scatter-layer').forEach(function (layer) {
      if (!layer.__scatterInit) initLayer(layer);
    });
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme Editor events
  document.addEventListener('shopify:section:load',   function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.scatter-layer').forEach(function (layer) {
      if (layer.__scatterDestroy) layer.__scatterDestroy();
    });
  });
})();
